import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Header from '../components/Header'
import { Container } from '../components/Container'
import Img from 'gatsby-image'

const InstagramFeed = ({ data: { allInstaNode } }) => (
  <Layout>
    <Header>Instagram feed</Header>
    <section className="section">
      <div className="container">
        <div className="container-pages" style={{ border: 'none' }}>
          <div className="text-promo-header">
            <a href="https://www.instagram.com/bhtelecom/" target="_blank">
              <h4 className="text-promo-large">Pratite BH Telecom na zvaničnom Instagram profilu</h4>
            </a>
          </div>
        </div>
        <Container nodes={allInstaNode} />
      </div>
    </section>
  </Layout>
)

export const pageQuery = graphql`
  query ScrapingQuery {
    allInstaNode(sort: { fields: [timestamp], order: DESC }) {
      edges {
        node {
          id
          username
          likes
          caption
          comments
          timestamp
          localFile {
            childImageSharp {
              fluid(quality: 100, maxWidth: 600, maxHeight: 600) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
                src
              }
            }
          }
        }
      }
    }
  }
`

export default InstagramFeed